import { render, staticRenderFns } from "./EditSpotPanelControl.global.vue?vue&type=template&id=18bfa311&scoped=true&lang=pug&"
import script from "./EditSpotPanelControl.global.vue?vue&type=script&lang=ts&"
export * from "./EditSpotPanelControl.global.vue?vue&type=script&lang=ts&"
import style0 from "./EditSpotPanelControl.global.vue?vue&type=style&index=0&id=18bfa311&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bfa311",
  null
  
)

export default component.exports